class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  isMobileHeaderSearch() {
    return (
      this.classList.contains('header__search--mobile') &&
      window.matchMedia('(max-width: 989px)').matches
    );
  }

  syncMobileSearchState(isOpen) {
    const header = this.closest('.header');
    if (!header) return;

    if (isOpen) {
      header.classList.add('header--mobile-search-open');
    } else {
      header.classList.remove('header--mobile-search-open');
    }

    const sectionHeader = document.querySelector('.section-header');
    if (sectionHeader) {
      document.documentElement.style.setProperty('--header-height', `${sectionHeader.offsetHeight}px`);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    if (!this.isMobileHeaderSearch()) {
      document.body.classList.add('overflow-hidden');
    } else {
      this.syncMobileSearchState(true);
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if (this.isMobileHeaderSearch()) {
      this.syncMobileSearchState(false);
    }
  }
}

customElements.define('details-modal', DetailsModal);
